// Builds the URL and copy-paste snippets for wiring a resource (or, when
// resourceName is omitted, an agent's whole unified endpoint) into a real
// MCP client. When agent routing is enabled (AGENT_ROUTING_ENABLED on the
// gateway) the URL embeds the agent (/mcp/{agent_name}[/{resource_name}] —
// the {agent} segment is matched against the agent_name column, not
// agent_id, see storage/repositories/agent_repo.py's get_by_name).
// Otherwise the gateway only supports the older path-based direct-access
// mode (/{resource_name}), which relies on the client sending an
// X-MCP-Agent header instead and has no agent-only (all-resources) URL.

export function buildConnectUrl(
  gatewayUrl: string,
  agentName: string,
  resourceName: string | undefined,
  agentRoutingEnabled: boolean
): string {
  const base = gatewayUrl.replace(/\/$/, '');
  if (agentRoutingEnabled) {
    return resourceName
      ? `${base}/mcp/${encodeURIComponent(agentName)}/${encodeURIComponent(resourceName)}`
      : `${base}/mcp/${encodeURIComponent(agentName)}`;
  }
  return `${base}/${encodeURIComponent(resourceName ?? '')}`;
}

export function buildClaudeCodeSnippet(
  resourceName: string | undefined,
  connectUrl: string,
  agentName: string,
  agentRoutingEnabled: boolean
): string {
  const name = resourceName || agentName;
  const header = agentRoutingEnabled ? '' : ` --header "X-MCP-Agent: ${agentName}"`;
  return `claude mcp add --transport http${header} ${name} ${connectUrl}`;
}

export function buildCodexSnippet(
  resourceName: string | undefined,
  connectUrl: string,
  agentName: string,
  agentRoutingEnabled: boolean
): string {
  const name = resourceName || agentName;
  const header = agentRoutingEnabled ? '' : ` --header "X-MCP-Agent: ${agentName}"`;
  return `codex mcp add ${name} --url ${connectUrl}${header}`;
}

export function buildMcpJsonSnippet(
  resourceName: string | undefined,
  connectUrl: string,
  agentName: string,
  agentRoutingEnabled: boolean
): string {
  const name = resourceName || agentName;
  return JSON.stringify(
    {
      mcpServers: {
        [name]: {
          type: 'http',
          url: connectUrl,
          ...(agentRoutingEnabled ? {} : { headers: { 'X-MCP-Agent': agentName } }),
        },
      },
    },
    null,
    2
  );
}
